import { createContext, useContext, useState } from 'react'

export const RegistrationUserContext = createContext()

export const RegistrationUserProvider = ({ children }) => {
  const [registrationUser, setRegistrationUser] = useState(null)

  return (
    <RegistrationUserContext.Provider
      value={{
        registrationUser,
        setRegistrationUser,
      }}
    >
      {children}
    </RegistrationUserContext.Provider>
  )
}

export const useRegistrationUserContext = () => {
  const PROVIDER_ERROR = 'useRegistrationUserContext must be used within an RegistrationUserProvider'
  const context = useContext(RegistrationUserContext)
  if (!context) {
    throw new Error(PROVIDER_ERROR)
  }
  return context
}

export default RegistrationUserContext
